/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { ModalContext } from 'App';
import _ from 'lodash';
import { Tabs, TabPanel } from 'react-tabs';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import { Acl } from 'modules/common/components/Acl';
import Alert from 'react-s-alert';
import { get } from 'session';
import Pagination from 'modules/common/components/Pagination';
import FileUploadModal from '../../../components/FileUploadModal';
import * as actions from '../../../action';
import * as c from '../../../constant';

const BirthCertificateFileImportContainer = ({
  getfileImportUploadList,
  list,
  isLoading,
  pager,
  // permissions,
}) => {
  const setModal = useContext(ModalContext);

  const handleOpenFileUploadModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <FileUploadModal moduleType="BC" subject="BIRTH_CERTIFICATE" />,
      title: 'Upload Files',
      modalSize: 'modal-md',
    });
  };

  // eslint-disable-next-line no-unused-vars
  const [formData, setFormData] = useState({
    subject: '',
  });

  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleSelect = (index) => {
    if (index === 0) {
      setFormData({
        subject: 'BIRTH_CERTIFICATE',
      });
      getfileImportUploadList({ subject: 'BIRTH_CERTIFICATE' });
      setSelectedIndex(0);
    }
  };

  const [token, setToken] = useState('');

  const [file, setFile] = useState({});

  const fileHandler = (e) => {
    setFile(e.target.files[0]);
  };

  const handleChangePageTab1 = (page) => {
    getfileImportUploadList({ ...formData, page });
  };

  useEffect(() => {
    getfileImportUploadList({ subject: 'BIRTH_CERTIFICATE' });

    setFormData({
      subject: 'BIRTH_CERTIFICATE',
    });
  }, []);

  const postFormData = (url) => (formdata, onProgress) =>
    new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest();
        xhr.timeout = 300000;
        // eslint-disable-next-line no-unused-vars
        xhr.addEventListener('timeout', (e) =>
          resolve({
            status: 400,
            message: 'Request Timeout, Please try again.',
          })
        );
        xhr.open('POST', url);
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.onload = () => {
          try {
            const jsonResponse = JSON.parse(xhr.response);
            const response = {
              status: xhr.status, // jsonResponse.status,
              data: jsonResponse,
            };
            resolve(response);
          } catch (err) {
            reject(err);
          }
        };
        xhr.onerror = () => {
          const errRes = {
            data: false,
            message: 'Oops..Something went wrong.',
          };
          Alert.error(errRes);
          return resolve(errRes);
        };
        if (xhr.upload) {
          xhr.upload.onprogress = (evt) => {
            if (evt.lengthComputable) {
              const progress = Math.ceil((evt.loaded / evt.total) * 100);
              if (onProgress) {
                onProgress(progress);
              }
            }
          };
        }
        xhr.send(formdata);
      } catch (err) {
        reject(err);
      }
    });

  const onUploadFile = async (e) => {
    e.preventDefault();

    const data = new FormData();

    try {
      data.append('file', file);
      data.append('subject', _.get(formData, 'subject'));
      const res = await postFormData(
        `${process.env.REACT_APP_WS}/api/v1/administrators/civil_registries/csv_imports`
      )(data);
      if (_.get(res, 'status') === 200) {
        Alert.success(_.get(res, 'data.message'));
        if (selectedIndex === 0) {
          getfileImportUploadList({ subject: 'BIRTH_CERTIFICATE' });
        }
      }
      if (_.get(res, 'status') === 422) {
        Alert.error(_.get(res, 'data.errors.subject.0'));
      }
      if (_.get(res, 'status') === 400) {
        const message = _.get(res, 'data.errors.0.detail');
        Alert.error(message);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err, 'err');
    }
  };

  useEffect(() => {
    const getToken = get('token') || '';
    setToken(getToken);
  }, []);

  return (
    <div className="mt-4">
      <Tabs onSelect={handleSelect}>
        {/* <TabList>
          <Tab>Birth Certificate</Tab>
        </TabList> */}
        <TabPanel>
          <div className="d-flex mt-2 px-2">
            <div className="ml-auto row-nav">
              {/* <div className="float-left">
                <div className="form-group">
                  {isLoading && (
                    <button
                      disabled
                      type="button"
                      className="btn btn-light btn-round border border-primary font-weight-bold px-4 ml-auto"
                    >
                      <i className="fa fa-spin fa-spinner" />
                    </button>
                  )}
                </div>
              </div> */}
              {/* <div className="float-right">
                <div className="form-group">
                  {!isLoading && (
                    <FilePondUpload />
                  )}
                </div>
              </div> */}
              <div className="flow-right">
                <div className="form-group">
                  <button
                    type="button"
                    onClick={handleOpenFileUploadModal}
                    className="ml-2 btn btn-link button-upload"
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              {isLoading ? (
                <div
                  className="loading d-flex text-center justify-content-center align-items-center"
                  style={{ height: '500px' }}
                >
                  <div className="spinner text-center ">
                    <span className="fas fa-5x fa-spin fa-spinner" />
                  </div>
                </div>
              ) : (
                <table className="table table-striped table-sm table-bordered table-hover">
                  <thead className="table-header">
                    <tr>
                      <th>DATE UPLOADED</th>
                      <th>SUBJECT</th>
                      <th>TAG</th>
                      <th>FILE NAME</th>
                      <th>YEAR</th>
                      <th>VOLUME</th>
                      <th>STATUS</th>
                      {/* <th>REMARKS</th> */}
                    </tr>
                  </thead>
                  <tbody className="table-details">
                    {list.map((item) => {
                      return (
                        <tr key={_.get(item, 'id')}>
                          <td>
                            {_.get(item, 'attributes.upload_date', '---')}
                          </td>
                          <td>{_.get(item, 'attributes.subject') || '---'}</td>
                          <td>{_.get(item, 'attributes.tag') || '---'}</td>
                          <td>
                            {_.get(item, 'attributes.file_name') || '---'}
                          </td>
                          <td>{_.get(item, 'attributes.year') || '---'}</td>
                          <td>{_.get(item, 'attributes.volume') || '---'}</td>
                          <td>{_.get(item, 'attributes.status') || '---'}</td>
                          {/* <td>{_.get(item, 'attributes.remarks') || '---'}</td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
              <div className="list-pagination">
                {pager.total_pages > 1 ? (
                  <div className="d-flex justify-content-center text-center align-item-center">
                    <Pagination data={pager} onChange={handleChangePageTab1} />
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
};

BirthCertificateFileImportContainer.propTypes = {
  getfileImportUploadList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  list: _.get(api, `${c.CIVIL_REG_FILE_IMPORT_LIST}.list`) || [],
  isLoading:
    _.get(api, 'loading', []).indexOf(c.CIVIL_REG_FILE_IMPORT_LIST) > -1,
  pager: _.get(api, `${c.CIVIL_REG_FILE_IMPORT_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BirthCertificateFileImportContainer);
